/**
 * Enhanced Total Quantity Calculator for Shopify Product Page
 * This script unifies the quantity calculation logic and properly handles multi-attribute products
 */
document.addEventListener('DOMContentLoaded', function() {
  setupTotalQuantityCalculator();
});

function setupTotalQuantityCalculator() {
  // Get all required elements
  const quantityInput = document.querySelector('input[name="quantity"]');
  const totalDisplays = document.querySelectorAll('[id^="TotalItems-"]');
  const addToCartButton = document.querySelector('.product-form__submit');
  
  if (!quantityInput || totalDisplays.length === 0) return;
  
  // 包装尺寸获取函数
  function getPackSize() {
    let packSize = 1;
    
    try {
      // 检查选中的单选按钮选项
      const selectedRadios = document.querySelectorAll('.product-form__input input[type="radio"]:checked');
      for(let radio of selectedRadios) {
        // 获取选项名称和值
        const optionWrapper = radio.closest('.product-form__input');
        const optionLabel = optionWrapper ? 
          (optionWrapper.querySelector('legend, label')?.textContent || '').toLowerCase() : '';
        const optionValue = radio.value.trim();
        
        // 检查选项名称是否包含数量相关词汇
        if(optionLabel.includes('pack') || 
           optionLabel.includes('count') || 
           optionLabel.includes('quantity') || 
           optionLabel.includes('size') ||
           optionLabel.includes('pieces') ||
           optionLabel.includes('pcs') ||
           optionLabel.includes('amount') ||
           optionLabel.includes('number')) {
          
          // 尝试从选项值中提取数字
          const matches = optionValue.match(/(\d+)/);
          if(matches && matches[1]) {
            const num = parseInt(matches[1], 10);
            if(!isNaN(num) && num > 0) {
              packSize = num;
              break;
            }
          }
        }
        
        // 如果选项值本身是数字，也将其作为潜在的包装尺寸
        const numValue = parseInt(optionValue, 10);
        if(!isNaN(numValue) && numValue > 0) {
          packSize = numValue;
          break;
        }
      }
      
      // 检查下拉选择框
      if(packSize === 1) {
        const selectedOptions = document.querySelectorAll('select.single-option-selector option:selected');
        for(let option of selectedOptions) {
          const selectLabel = option.closest('select')?.previousElementSibling?.textContent.toLowerCase() || '';
          const optionValue = option.value.trim();
          
          if(selectLabel.includes('pack') || 
             selectLabel.includes('count') || 
             selectLabel.includes('quantity') || 
             selectLabel.includes('size') ||
             selectLabel.includes('pieces') ||
             selectLabel.includes('pcs') ||
             selectLabel.includes('amount') ||
             selectLabel.includes('number')) {
            
            const matches = optionValue.match(/(\d+)/);
            if(matches && matches[1]) {
              const num = parseInt(matches[1], 10);
              if(!isNaN(num) && num > 0) {
                packSize = num;
                break;
              }
            }
          }
          
          const numValue = parseInt(optionValue, 10);
          if(!isNaN(numValue) && numValue > 0) {
            packSize = numValue;
            break;
          }
        }
      }
    } catch(e) {
      console.error('Error getting pack size:', e);
    }
    
    return packSize;
  }
  
  // Update total quantity displays
  function updateTotalQuantity() {
    const quantity = parseInt(quantityInput.value, 10) || 1;
    const packSize = getPackSize();
    const totalItems = quantity * packSize;
    
    // Update all total displays
    totalDisplays.forEach(display => {
      display.textContent = totalItems;
    });
    
    // Optional: Update the add to cart button text
    if (addToCartButton) {
      const buttonText = addToCartButton.querySelector('.button__text');
      if (buttonText) {
        buttonText.dataset.originalText = buttonText.dataset.originalText || buttonText.textContent;
        // Only update if total > 1 to avoid confusion
        if (totalItems > 1) {
          buttonText.textContent = `${buttonText.dataset.originalText} · Total: ${totalItems} items`;
        } else {
          buttonText.textContent = buttonText.dataset.originalText;
        }
      }
    }
  }
  
  // Initial update
  updateTotalQuantity();
  
  // 监听数量变化
  document.addEventListener('change', function(event) {
    if (event.target && event.target.matches('input[name="quantity"]')) {
      updateTotalQuantity();
    }
  });
  
  // 使用 MutationObserver 监听数量输入框的值变化
  const quantityObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
        updateTotalQuantity();
      }
    });
  });
  
  if (quantityInput) {
    quantityObserver.observe(quantityInput, { 
      attributes: true,
      attributeFilter: ['value']
    });
  }
  
  // 关键改进：监听变体选择器并观察其变化
  const variantSelectors = document.querySelectorAll('.product-form__input');
  variantSelectors.forEach(selector => {
    // 为每个变体选择器创建一个观察器
    const variantObserver = new MutationObserver(function() {
      // 当变体选择器发生变化时，更新总量显示
      updateTotalQuantity();
    });
    
    // 观察变体选择器的属性和子元素变化
    variantObserver.observe(selector, {
      childList: true,
      subtree: true,
      attributes: true
    });
  });
  
  // 监听选项变化
  document.addEventListener('change', function(event) {
    if (event.target && (
      event.target.matches('.product-form__input input[type="radio"]') || 
      event.target.matches('.single-option-selector') ||
      event.target.closest('.product-form__input'))
    ) {
      // 给浏览器一点时间更新DOM
      setTimeout(updateTotalQuantity, 10);
    }
  });
  
  // 重要：监听 Shopify 的变体变化事件
  // 这是确保与Shopify原生行为同步的关键
  document.addEventListener('variant:change', function() {
    // 给浏览器一点时间更新数量输入框
    setTimeout(updateTotalQuantity, 50);
  });
  
  // 重要：额外监听变体更改事件
  // Dawn主题和许多其他主题使用这些自定义事件
  document.addEventListener('variantChange', updateTotalQuantity);
  document.addEventListener('variant:changed', updateTotalQuantity);
  
  // 监听数量按钮点击
  document.addEventListener('click', function(event) {
    if (event.target && (
      event.target.closest('.quantity__button[name="plus"]') || 
      event.target.closest('.quantity__button[name="minus"]'))
    ) {
      // 给值变化一点时间
      setTimeout(updateTotalQuantity, 50);
    }
  });
  
  // 关键改进：定期轮询检查数量值
  // 这是一个后备方案，确保即使其他方法失败，总量显示也会更新
  let lastQuantity = quantityInput.value;
  let lastPackSize = getPackSize();
  
  setInterval(function() {
    const currentQuantity = quantityInput.value;
    const currentPackSize = getPackSize();
    
    // 如果数量或包装尺寸变化了，更新总量显示
    if (currentQuantity !== lastQuantity || currentPackSize !== lastPackSize) {
      lastQuantity = currentQuantity;
      lastPackSize = currentPackSize;
      updateTotalQuantity();
    }
  }, 500); // 每半秒检查一次
  
  // 页面加载和重新加载时更新
  document.addEventListener('shopify:section:load', function() {
    setTimeout(updateTotalQuantity, 100);
  });
}